// Mock data and handlers for Trademark Registration Website

export const mockContactSubmit = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', formData);
      resolve({
        success: true,
        message: 'Thank you! Our trademark experts will contact you within 24 hours.',
        data: formData
      });
    }, 800);
  });
};

export const mockNewsletterSubscribe = (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Newsletter subscription:', email);
      resolve({
        success: true,
        message: 'Successfully subscribed to trademark updates!'
      });
    }, 600);
  });
};

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    company: "TechStart Innovations",
    rating: 5,
    text: "Trademark Texticon made the entire registration process seamless. They handled everything from the initial search to final USPTO approval. Highly recommend their Deluxe package!",
    industry: "Technology"
  },
  {
    id: 2,
    name: "Michael Chen",
    company: "Artisan Coffee Co.",
    rating: 5,
    text: "Professional, efficient, and knowledgeable. They protected our brand name and logo perfectly. The dedicated case manager was incredibly helpful throughout the process.",
    industry: "Food & Beverage"
  },
  {
    id: 3,
    name: "Jennifer Martinez",
    company: "Wellness Studio",
    rating: 5,
    text: "Best investment for my business! Their comprehensive search saved me from potential legal issues. The team's expertise in trademark law is outstanding.",
    industry: "Health & Wellness"
  },
  {
    id: 4,
    name: "David Thompson",
    company: "Urban Apparel",
    rating: 5,
    text: "Fast, reliable, and affordable. Got my trademark registered in record time. The Platinum package was worth every penny for the peace of mind it provides.",
    industry: "Fashion & Retail"
  }
];

export const trademarkStats = {
  trademarksRegistered: "1000+",
  yearsExperience: "15+",
  successRate: "98%",
  clientSatisfaction: "99%",
  averageProcessingTime: "6-8 months",
  statesServed: "All 50 States"
};

export const industries = [
  { name: "Technology & Software", icon: "Laptop" },
  { name: "Food & Beverage", icon: "Coffee" },
  { name: "Fashion & Apparel", icon: "Shirt" },
  { name: "Health & Wellness", icon: "Heart" },
  { name: "Professional Services", icon: "Briefcase" },
  { name: "Entertainment & Media", icon: "Video" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Retail & E-commerce", icon: "ShoppingBag" },
  { name: "Real Estate", icon: "Home" },
  { name: "Education", icon: "GraduationCap" }
];

export const faqs = [
  {
    question: "What is a trademark and why do I need one?",
    answer: "A trademark is a unique symbol, word, phrase, design, or combination that identifies and distinguishes your products or services from others. Registering a trademark provides legal protection for your brand, prevents others from using similar marks, and gives you exclusive rights to use the mark nationwide in connection with your goods or services."
  },
  {
    question: "How long does the trademark registration process take?",
    answer: "The typical trademark registration process takes 6-12 months from filing to registration, depending on the complexity of your application and whether any office actions are issued by the USPTO. Our team monitors your application throughout the entire process and handles any correspondence with the USPTO to ensure smooth processing."
  },
  {
    question: "What's the difference between ™ and ®?",
    answer: "The ™ symbol indicates that you're claiming trademark rights to a mark, even if it's not registered. The ® symbol can only be used once your trademark is officially registered with the USPTO. Using ® before registration is illegal and can result in penalties. We'll guide you on proper trademark symbol usage throughout the process."
  },
  {
    question: "Can I trademark a business name?",
    answer: "Yes, you can trademark a business name if you use it in commerce to identify your goods or services. However, simply registering a business with your state doesn't provide trademark protection. Federal trademark registration with the USPTO offers broader protection across all states and is essential for comprehensive brand protection."
  },
  {
    question: "What is a comprehensive trademark search?",
    answer: "A comprehensive trademark search examines existing registered trademarks, pending applications, and common law uses to identify potential conflicts with your proposed mark. This crucial step helps assess the likelihood of successful registration and reduces the risk of infringement issues. Our Deluxe and Platinum packages include extensive search reports."
  },
  {
    question: "What happens if my trademark application is refused?",
    answer: "If the USPTO issues an office action or refusal, don't worry—this is common. Our experienced attorneys will review the refusal, prepare a detailed response, and work to overcome any objections. Our higher-tier packages include office action responses and have a high approval rate for overcoming initial refusals."
  },
  {
    question: "How much does trademark registration cost?",
    answer: "Our packages range from $45 to $349 plus USPTO filing fees (currently $250-$350 per class). The total cost depends on the level of service you choose and the number of classes your trademark covers. We offer transparent pricing with no hidden fees, and our packages include various levels of search, monitoring, and legal support."
  },
  {
    question: "Do I need to renew my trademark?",
    answer: "Yes, trademark registrations require maintenance filings. You must file a Declaration of Use between the 5th and 6th year after registration, and renewal filings every 10 years. Our trademark monitoring services can remind you of these deadlines and assist with the renewal process to maintain your trademark protection."
  },
  {
    question: "Can I trademark a logo and business name together?",
    answer: "Yes, you can file separate applications for your business name and logo, or file a combined mark that includes both. We recommend filing separate applications for maximum protection, allowing you to use the name and logo independently. Our team will advise on the best strategy for your specific situation."
  },
  {
    question: "What classes should I register my trademark under?",
    answer: "Trademarks are registered by classes that categorize different types of goods and services. The USPTO has 45 classes total. We'll help you identify the appropriate classes based on your current and planned business activities. Each class requires a separate filing fee, so strategic class selection is important for cost-effective protection."
  }
];
